/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsImportHistoricalResults } from "../../funcs/llmEvalsImportHistoricalResults.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ImportHistoricalEvalResultsRequest$inboundSchema,
};

export const tool$llmEvalsImportHistoricalResults: ToolDefinition<typeof args> =
  {
    name: "llm-evals-import-historical-results",
    description: `Import historical eval results from Hugging Face

Imports simplified historical samples.jsonl-style eval results from a Hugging Face dataset repository into a completed eval suite run shape. Aggregates are recomputed from samples and include canonical score metrics for leaderboards.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await llmEvalsImportHistoricalResults(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
